export interface ClassTimeLike {
  label?: string;
  startTime?: string;
  endTime?: string;
}

/**
 * Formats preferred class time for lead payloads.
 * Returns "start - end" when both values exist,
 * otherwise returns label if present.
 */
export function formatPreferredClassTime(classTime: ClassTimeLike | undefined): string | undefined {
  if (!classTime) {
    return undefined;
  }

  const { startTime, endTime, label } = classTime;

  if (startTime && endTime) {
    return `${startTime} - ${endTime} (UTC)`;
  }

  return label || undefined;
}
